import { render } from "./bs_modal.vue?vue&type=template&id=2386b3f0"
import script from "./bs_modal.vue?vue&type=script&lang=js"
export * from "./bs_modal.vue?vue&type=script&lang=js"

import "./bs_modal.vue?vue&type=style&index=0&id=2386b3f0&lang=css"

import exportComponent from "/var/deploy/production_one/web_head/releases/20260421203917/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__